import { Subjects } from "../permission/constants";

export class Collection {
  owner: number;

  static get modelName(): string {
    return Subjects.COLLECTION;
  }

  constructor(owner: number) {
    this.owner = owner;
  }
}
